<template>
    <app-layout class="main">
        <div class="row expanded panel-container">
            <panel>
                <h2 slot="header" class="title">Autorizējies</h2>

                <div class="row social-buttons">
                    <button type="button" class="button mykoob large expanded" @click="getRedirect('mykoob')">MyKoob</button>
                    <button type="button" class="button eklase large expanded" @click="getRedirect('eklase')">E-klase</button>
                </div>

                <div class="or fancy"><span></span><span>vai</span><span></span></div>

                <login-form></login-form>

            </panel>
        </div>
    </app-layout>
</template>

<script>
    import LoginForm from '../components/auth/LoginForm'
    import AppLayout from '../layouts/AppLayout'
    import Panel from '../components/Panel'
    import auth from '../api/auth'

    export default  {

        methods: {
            getRedirect(provider) {
                auth.redirect(provider);
            }
        },

        components: {
            LoginForm, AppLayout, Panel
        },

    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .social-buttons {
        flex-wrap: nowrap;

        > *:not(:last-child) {
            margin-right: 1rem;
        }
    }

    .or.fancy {
        margin-bottom: 1rem;
        color: $color-light-gray;

        > span:first-child,
        > span:last-child {
            border-top-color: $color-light-gray;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Login.vue